import { useMutation } from '@tanstack/react-query';
import useProjectSystem from '@projects/systems/useProjectSystem';
import { ProjectPermissions } from '@projects/systems/ProjectSystem';

type UseUpdateProjectPermissionsMutationParams = {
	projectID: number;
	onSuccess?: ( permissions: ProjectPermissions ) => void;
};

const useUpdateProjectPermissionsMutation = ( {
	projectID, onSuccess
}: UseUpdateProjectPermissionsMutationParams ) => {
	const system = useProjectSystem();

	return useMutation(
		( permissions: ProjectPermissions ) => system.updateProjectPermissions( { projectID, permissions } ),
		{ onSuccess: ( _, permissions ) => onSuccess?.( permissions ) }
	);
};

export default useUpdateProjectPermissionsMutation;
